import moment from 'moment'
import PropTypes from 'prop-types'
import { createRef, PureComponent } from 'react'
import { Button, Divider, Icon } from 'semantic-ui-react'

import APP from 'app'

import Message from '../modals/Message'
import BlockTitle from './BlockTitle'

import './HTMLPrinter.css'

class HTMLPrinter extends PureComponent {
  constructor(props) {
    super(props)

    this.contentEl = createRef()
    this.dataEl = createRef()
    this.formEl = createRef()

    this.id = `htmlPrint_${new Date().getTime()}`
  }

  saveImage = () => {
    const styles = document.querySelectorAll('style')
    const stylesheets = document.querySelectorAll('link[rel="stylesheet"]')
    let content = ''

    styles.forEach((style) => {
      content += style.outerHTML
    })
    stylesheets.forEach((style) => {
      content += style.outerHTML
    })
    this.dataEl.current.value = content + this.contentEl.current.outerHTML
    this.formEl.current.submit()
  }

  render() {
    const { children } = this.props

    return (
      <Message autosize className="HTMLPrinter" onClose={this.props.onClose}>
        <BlockTitle>
          <br />
          <Icon name="print" size="large" /> Vista previa de la impresión:{' '}
          <Button color="black" onClick={this.saveImage} size="small">
            <Icon name="file archive outline" /> Generar Descargable
          </Button>
        </BlockTitle>
        <Divider fitted />
        <div id={this.id} className="HTMLPrinter__content" ref={this.contentEl}>
          <div className="HTMLPrinter__generation">Generación: {moment().format('YYYY-MM-DD HH:mm')}</div>
          {children}
        </div>
        <form
          id={`form_${this.id}`}
          action={`${APP.services}/export/data/image`}
          encType="multipart/form-data"
          method="POST"
          ref={this.formEl}
          target="_blank"
        >
          <input id={`form_data_${this.id}`} name="data" ref={this.dataEl} type="hidden" value="" />
        </form>
      </Message>
    )
  }
}

HTMLPrinter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClose: PropTypes.func.isRequired,
}

export default HTMLPrinter
